// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 0px 40px;
}

.aboutTitle {
  font-size: 1000%;
  font-style: italic;
  margin-top: 0px;
  margin-bottom: 0px;
  animation: aboutLoad 500ms ease-in;
}

.headshot {
  width: 350px;
  height: 450px;
  object-fit: cover;
  margin-top: 16px;
  animation: headshotLoad 500ms ease-in;
}

.aboutContainer {
  display: flex;
  align-items: center;
  width: 50%;
  justify-content: center;
}

.aboutTextContainer {
  margin-left: 40px;
}

.aboutTextContainer > p {
  margin: 0px;
  animation: fadeIn linear 1.5s;
  line-height: 200%;
  font-size: 110%;
}

.connectButton {
  background-color: #000099;
  color: #faf9f6;
  width: auto;
  font-size: 20px;
  border: 2px solid #000099;
  border-radius: 100px;
  padding: 8px 24px;
  text-decoration: none;
  animation: aboutLoad 700ms ease-in;
  margin-top: 40px;
}

.connectLink {
  text-decoration: none;
  font-weight: 200;
  font-family: 'HelveticaNeue';
  color: #faf9f6;
  padding: 0px;
  margin: 0px;
}

@keyframes aboutLoad {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(0);
  }
}

@keyframes headshotLoad {
  0% {
    transform: translateY(100%);
  }

  100% {
    transform: translateY(0);
  }
}

@media only screen and (max-width: 768px) {
  .aboutContainer {
    flex-direction: column-reverse;
    width: 100%;
  }
  .aboutTextContainer {
    margin-left: 0;
    align-items: flex-start;
  }
  .aboutTitle {
    text-align: left;
  }
}
@media only screen and (max-width: 391px) {
  .headshot {
    width: 200px;
    height: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/About.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,WAAW;EACb;EACA;IACE,cAAc;IACd,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,YAAY;IACZ,YAAY;EACd;AACF","sourcesContent":[".about {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  margin: 0px 40px;\n}\n\n.aboutTitle {\n  font-size: 1000%;\n  font-style: italic;\n  margin-top: 0px;\n  margin-bottom: 0px;\n  animation: aboutLoad 500ms ease-in;\n}\n\n.headshot {\n  width: 350px;\n  height: 450px;\n  object-fit: cover;\n  margin-top: 16px;\n  animation: headshotLoad 500ms ease-in;\n}\n\n.aboutContainer {\n  display: flex;\n  align-items: center;\n  width: 50%;\n  justify-content: center;\n}\n\n.aboutTextContainer {\n  margin-left: 40px;\n}\n\n.aboutTextContainer > p {\n  margin: 0px;\n  animation: fadeIn linear 1.5s;\n  line-height: 200%;\n  font-size: 110%;\n}\n\n.connectButton {\n  background-color: #000099;\n  color: #faf9f6;\n  width: auto;\n  font-size: 20px;\n  border: 2px solid #000099;\n  border-radius: 100px;\n  padding: 8px 24px;\n  text-decoration: none;\n  animation: aboutLoad 700ms ease-in;\n  margin-top: 40px;\n}\n\n.connectLink {\n  text-decoration: none;\n  font-weight: 200;\n  font-family: 'HelveticaNeue';\n  color: #faf9f6;\n  padding: 0px;\n  margin: 0px;\n}\n\n@keyframes aboutLoad {\n  0% {\n    transform: translateX(100%);\n  }\n\n  100% {\n    transform: translateX(0);\n  }\n}\n\n@keyframes headshotLoad {\n  0% {\n    transform: translateY(100%);\n  }\n\n  100% {\n    transform: translateY(0);\n  }\n}\n\n@media only screen and (max-width: 768px) {\n  .aboutContainer {\n    flex-direction: column-reverse;\n    width: 100%;\n  }\n  .aboutTextContainer {\n    margin-left: 0;\n    align-items: flex-start;\n  }\n  .aboutTitle {\n    text-align: left;\n  }\n}\n@media only screen and (max-width: 391px) {\n  .headshot {\n    width: 200px;\n    height: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
